export const typesMessages = {
  archived: {
    icon: "warning",
    title: (type) => `This action will move the ${type} to Trash`,
    text: `It will no longer be available for active use, but will remain in the system history.`,
  },
  active: {
    icon: "warning",
    title: (type) => `This action will move the ${type} to Trash`,
    text: "It will no longer be available for active use, but will remain in the system history.",
  },
  obsolete: {
    icon: "warning",
    title: (type) => `This action will move the ${type} to Trash`,
    text: "It will no longer be available for active use, but will remain in the system history.",
  },
};
